var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCrossCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0A7.493 7.493 0 0 0 .5 7.5C.5 11.648 3.853 15 8 15c4.148 0 7.5-3.352 7.5-7.5C15.5 3.353 12.148 0 8 0Zm3.225 10.725a.747.747 0 0 1-1.057 0L8 8.557l-2.168 2.168a.747.747 0 1 1-1.057-1.057L6.942 7.5 4.776 5.332a.747.747 0 1 1 1.057-1.057L8 6.442l2.168-2.167a.747.747 0 1 1 1.057 1.057L9.057 7.5l2.168 2.168a.76.76 0 0 1 0 1.057Z",
  fill: "#9B9B9B"
})));
export default SvgCrossCircle;